<!--分类大小类下拉框-->
<template>
  <div>
    <el-select v-model="bigId" placeholder="大类"
               :clearable="true"
               @change="bigCategoryChange"
               style="width: 49%!important;"
    >
      <el-option v-for="item in options0"
                 :key="item.id"
                 :label="item.typeName"
                 :value="item.id"
      >
      </el-option>
    </el-select>
    <el-select v-model="smallId"
               placeholder="小类"
               :clearable="true"
               @change='smallCategorySelectChang'
               style="width: 49%!important;margin-left:2%;"
    >
      <el-option v-for="item in options1"
                 :key="item.id"
                 :label="item.typeName"
                 :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import api from "@/api/projectApi";

export default {
  name: 'feeTypeSelect',
  props: {
    bigId: {
      type: [String, Number],
      require: true
    },
    smallId: {
      type: [String, Number],
      require: true
    }
  },

  computed: {},

  mounted() {
    this.loadBigCategory()
    this.loadSmallCategory()
  },

  data() {
    return {
      options0: [],
      options1: [],
      first: true,
    }
  },

  watch: {
    bigId: {
      handler(n) {
        if (n && this.first) {
          this.loadSmallCategory()
        }
      }
    }
  },


  methods: {
    bigCategoryChange() {
      this.$emit('update:bigId', this.bigId)
      this.smallId = null
      this.$emit('update:smallId', this.smallId)
      this.loadSmallCategory()
    },

    smallCategorySelectChang() {
      this.$emit('update:smallId', this.smallId)
    },

    // 加载大类
    loadBigCategory() {
      this.$http.post(api.sfFeeType.getList, {usable: 1, parentId: 0}).then(res => {
        let list = res.data.data
        console.log('大类', list)
        this.options0 = list
      })
    },

    // 加载小类
    loadSmallCategory() {
      if (this.bigId) {
        this.$http.post(api.sfFeeType.getList, {
          usable: 1, parentId: this.bigId
        }).then(res => {
          let list = res.data.data
          console.log('小类', list)
          this.options1 = list
          this.first = false
        })
      } else {
        this.options1 = []
      }
    },
  },
};
</script>

<style scoped lang="scss">

</style>
